const o = `<svg slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<path d="M12 6L8 10L4 6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
</svg>`, n = `<svg slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<path d="M4 10L8 6L12 10" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
</svg>`;
export {
  n,
  o
};
